// TopItemRevenuePage.js
import React from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import Export from "../../../../components/Export";
// import Export from "./Export"; // adjust the import path if needed

const TopItemRevenuePage = ({
  objects,
  itemDataRevenue,
  range,
  storess,
  chartDataTopRevenue,
  printChart,
  exportToCSV,
  formatSales,
}) => {
  // Derive formatted dates (assuming `range.tran_date` has $gte / $lte in ISO strings)
  const formattedStart = range?.tran_date?.["$gte"]?.split("T")[0] ?? "";
  const formattedEnd = range?.tran_date?.["$lte"]?.split("T")[0] ?? "";

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center">
        <h1 className="fw-bold mt-3 text-capitalize text-black">
          Top&nbsp;
          <span style={{ color: "#83c14a" }}>Menu Items</span>&nbsp; by&nbsp;
          <span style={{ color: "#D1DE48" }}>Revenue</span>
        </h1>

        {/* Export buttons: */}
        <Export
          exportPdf={() => printChart("chart-container-top-revenue")}
          exportCsv={() => exportToCSV("revenue", true, 1000)}
        />
      </div>

      {objects?.length > 0 ? (
        <div id="chart-container-top-revenue" className="chart-container">
          <div className="card">
            <HighchartsReact
              highcharts={Highcharts}
              options={chartDataTopRevenue}
            />
          </div>

          <div className="print-only-content">
            <h2>Report Details</h2>

            <div className="d-flex justify-content-between align-items-center print-only-content">
              <h3>Brand: Angels Pizza</h3>
              <h4 className="mx-auto"></h4>
              <h3>Store: {storess}</h3>
              <h3>
                Date Range:&nbsp;
                <span>{formattedStart}</span>&nbsp;
                <span>{formattedEnd}</span>
              </h3>
              <h3>Top Menu Items By Revenue</h3>
            </div>

            <div className="print-only" style={{ fontSize: "20px" }}>
              <table className="table text-center">
                <thead>
                  <tr className="d-flex">
                    <th>Menu Item</th>
                    <th className="ms-5">Revenue</th>
                    <th className="ms-5">Quantity</th>
                  </tr>
                </thead>

                <tbody>
                  {Object.entries(itemDataRevenue)
                    .sort((a, b) => b[1].sales - a[1].sales)
                    .slice(0, 100)
                    .map(([itemCode, itemDetails]) => (
                      <tr key={itemCode}>
                        <td
                          style={{
                            textAlign: "center",
                            verticalAlign: "middle",
                          }}
                        >
                          {itemDetails.description}
                        </td>
                        <td
                          style={{
                            textAlign: "center",
                            verticalAlign: "middle",
                          }}
                        >
                          {formatSales(itemDetails.sales)}
                        </td>
                        <td
                          style={{
                            textAlign: "center",
                            verticalAlign: "middle",
                          }}
                        >
                          {itemDetails.quantity}
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      ) : (
        <div className="text-center align-items-center mt-4">
          <img
            src="./choosefirst.png"
            style={{ height: "200px", width: "200px" }}
            alt="Choose date range and store"
          />
          <h4 className="mt-4 fw-semibold text-muted text-center">
            👋 To get started, please select a{" "}
            <span className="text-success">date range</span> and{" "}
            <span className="text-success">store</span> above.
          </h4>
        </div>
      )}
    </div>
  );
};

export default TopItemRevenuePage;
